// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2vRgN","containerItemsCenter":"Skeleton_containerItemsCenter__2f4Ao"};